/**
 * Checks if the firebase user objects permissions include either a single string of a role or an array of roles
 * @param {Object} user Firebase user object
 * @param {string|string[]} roles Single role in string format or multiple in array
 */
export const hasPositions = (user, positions) => (
  user && user.permissions && user.permissions[user.defaultVenue].position.some((position) => positions.includes(position))
);

/**
 * Checks if the firebase user object is a superUser
 * @param {Object} user Firebase user object
 * @returns {bool}
 */
export const isSuperUser = (user) => user && !!user.superUser;


/**
 * Checks if the user has a developer flag
 * @param {Object} user Firebase user object
 * @returns {bool}
 */

export const isDev = (user) => user && !!user.dev;
